module.exports = __webpack_public_path__ + "img/sleeve_opening.af22f70c.png";